import { useContext } from 'react';
import { TestMasterContext } from '../contexts/TestMasterContext';

export const useTestMasters = () => {
  const context = useContext(TestMasterContext);
  
  if (!context) {
    throw new Error('useTestMasters must be used within a TestMasterProvider');
  }
  
  return context;
};
